module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "show": _vm.showModal
    },
    on: {
      "close": _vm.setCloseModal
    }
  }, [_c('h1', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('vue2.createusers.create_users')))]), _vm._v(" "), _c('div', {
    staticClass: "cu",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "cu-tab-content"
  }, [_c('createUserForm', {
    attrs: {
      "country": _vm.country,
      "pushname": _vm.pushNameFromSelect2
    },
    on: {
      "editedUsers": _vm.setUsers,
      "onNameInput": _vm.checkForDoubleNames
    }
  }), _vm._v(" "), (_vm.isSchoolSystem) ? _c('div', {
    staticClass: "auto-users"
  }, [(!_vm.showAutoUsersInput) ? _c('div', {
    staticClass: "auto-users__button",
    on: {
      "click": _vm.openAutoUsersInput
    }
  }, [_c('span', {
    staticClass: "plus--icon"
  }, [_vm._v("+")]), _vm._v(" "), _c('span', {
    staticClass: "auto-users__button-text"
  }, [_vm._v("Auto brugere")])]) : _c('div', {
    staticClass: "auto-users__form"
  }, [_c('span', [_vm._v("Antal:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.autoUsersCount),
      expression: "autoUsersCount",
      modifiers: {
        "number": true
      }
    }],
    ref: "autoUsersCount",
    staticClass: "auto-users__count",
    attrs: {
      "type": "number",
      "min": "1",
      "max": _vm.maxAutoUsers
    },
    domProps: {
      "value": (_vm.autoUsersCount)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.createAutoUsers.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.autoUsersCount = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "submit-button",
    on: {
      "click": _vm.createAutoUsers
    }
  }, [_vm._v("Opret " + _vm._s(_vm.autoUsersCount) + " brugere")]), _vm._v(" "), _c('span', {
    staticClass: "auto-users__cancel",
    on: {
      "click": function($event) {
        _vm.showAutoUsersInput = false
      }
    }
  }, [_vm._v("Annuller")])])]) : _vm._e(), _vm._v(" "), (_vm.isTestSchool) ? _c('SearchForCalendar', {
    staticStyle: {
      "border-top": "1rem solid #edf0f5"
    },
    attrs: {
      "query": _vm.activeInputName,
      "calendarType": "users"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
    staticClass: "flex flex-end pad-10",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.showInactiveButton) ? _c('button', {
    staticClass: "create-form__submit"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.createusers.create')) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.usersToSubmit.length > 0) ? _c('button', {
    staticClass: "submit-button",
    on: {
      "click": _vm.submitUsers
    }
  }, [_vm._v("\n      " + _vm._s(_vm.buttonText) + "\n    ")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dbf319dc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreateCalendars/CreateUser/CreateUser.vue
// module id = 2139
// module chunks = 1